import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"sq-loading-manager-container\">\n  {{yield}}\n</div>", {
  moduleName: "@dashboard/shared-ui/components/sq-loading-manager.hbs"
});